<template>
  <div id="app" v-if="navigationBarType">
    <navigationBar :menuArr="menuArr"></navigationBar>
    <navigationBarLeft :menuLeftArr="menuLeftArr" :activeIndex="activeIndex"></navigationBarLeft>
    <div class="main">
      <router-view/>
    </div>
  </div>
  <div id="appNo" v-else>
    <router-view/>
  </div>
</template>

<script>
import navigationBar from '@/components/navigationBar'
import navigationBarLeft from '@/components/navigationBarLeft'
import api from '@/api/api.js'
import {get, post} from '@/api/index.js'
export default {
  name: 'App',
  data () {
    return {
      activeIndex: '/merchants/contractInformation',
      navigationBarType: true,
      navigationBarLeftType: true,
      navWhiteList: ['Login','index'],
      menuLeftArr: [],
      menuArr: []
    }
  },
  watch:{
    $route(to,from){
      console.log(from.name)
      if (from.name == 'Login') {
        post( api.getMenu ).then((d) => {
          // if (d.status == 0) {
          //   this.menuArr = d.data
          //   var path = '/' + this.$router.history.current.path.split('/')[1]
          //   for (let i = 0; i < d.data.length; i++) {
          //     if (path == d.data[i].path) {
          //       this.menuLeftArr = d.data[i].submenu
          //       sessionStorage.setItem('menuLeftArr',d.data[i].submenu)
          //     }
          //   }
          // }
        }, (err) => {

        })
      }
      // console.log(to.name,'ppppppppppppppppppppppppppppppppppppppp')
      if (this.navWhiteList.indexOf(to.name) >= 0) {
        this.navigationBarType = false
      }else {
        this.navigationBarType = true
      //   if (to.name == 'Home') {
      //     this.navigationBarLeftType = false
      //   }else {
      //     this.navigationBarLeftType = true
      //   }
      }
    }
  },
  components: {
      navigationBar: navigationBar,
      navigationBarLeft: navigationBarLeft
  },
  mounted() {
    // 导航菜单状态获取
    this.activeIndex = sessionStorage.getItem('activeIndex') || '0-0'
    // post( api.getMenu ).then((d) => {
      // if (d.status == 0) {
      //   this.menuArr = d.data
      //   sessionStorage.setItem('menuArr', JSON.stringify(d.data))
      //   var path = '/' + this.$router.history.current.path.split('/')[1]
      //   for (let i = 0; i < d.data.length; i++) {
      //     if (path == d.data[i].path) {
      //       this.menuLeftArr = d.data[i].submenu
      //       sessionStorage.setItem('menuLeftArr', JSON.stringify(d.data[i].submenu))
      //     }
      //   }
      // }else {
      //   this.menuArr = sessionStorage.getItem('menuArr')
      // }
    // }, (err) => {

    // })
    // console.log(this.$router.history)
    if (!localStorage.getItem('nameList')) {
      post( api.nameList ).then((d) => {
          if (d.status == 0) {
            var arr = []
            for (let i = 0; i < d.data.length; i++) {
              var obj = {
                value : d.data[i].id,
                label : d.data[i].name
              }
              arr.push(obj)
            }
            console.log(arr)
            localStorage.setItem('nameList', JSON.stringify(arr))
          }
      }, (err) => {

      })
    }
  },
  created() {
    // console.log(this.$route.path)
    if (this.navWhiteList.indexOf(this.$router.history.current.name) >= 0) {
      this.navigationBarType = false
    }else {
      this.navigationBarType = true
      // if (this.$router.history.current.name == 'Home') {
      //   this.navigationBarLeftType = false
      // }else {
      //   this.navigationBarLeftType = true
      // }
    }
  },
  methods:{
    // handleSelect(val,arr) {
    //   this.menuLeftArr = arr
    //   // console.log(this.$router.history.current.path.indexOf(val) < 0)
    //   if (val != '') {
    //     this.$router.push({path: val})
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .main {
    float: left;
    width: calc(100% - 182px);
    height: calc(100% - 58px);
    background:rgba(121, 184, 255, 0.3);
    overflow-y: auto;
  }
  .appMain {
    width: 100%;
    height: calc(100% - 58px);
    background:rgba(121, 184, 255, 0.3);
    overflow-y: auto;
  }
}
#appNo {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<style>
.loading {
  display: inline-block;
  width: 54px;
  height: 56px;
  background: url(./assets/img/bars.svg);
  background-size: cover;
}
.el-input--suffix .el-input__inner {
  height: 34px !important;
}
/* .el-range-editor.el-input__inner {
  height: 34px !important;
} */
.el-input__inner {
  height: 34px !important;
}
/* .el-select .el-input .el-select__caret {
  margin-top: 3px !important;
} */
.el-date-editor--daterange.el-input__inner{
  width: 346px !important;
  line-height: 30px !important;
}
.el-table td div {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}
.el-select .el-input .el-select__caret{
  line-height: 46px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue